<div class="header-info">
  <h4 class="header4-text" ngbAutofocus>Calibrate</h4>
</div>
<section class="calibration-body">
  <p>Click and drag between two points of a known dimension to calibrate.</p>
</section>
<div class="buttons-container calibration-button-container">
  <button class="btn btn-primary" (click)="modal.close()">OK</button>
</div>
